import {
  HeroZero as HeroZeroUi,
  HeroZeroProps as HeroZeroPropsUi,
} from '@sbercloud/uikit-product-site-hero';
import { useRouter } from 'next/navigation';
import { useLayoutType } from 'src/hooks/useLayoutType';

export type HeroZeroProps = Omit<HeroZeroPropsUi, 'layoutType'>;

function HeroZero({
  title,
  description,
  breadcrumbs,
  buttons,
  backgroundColor,
  showBottomPadding,
}: HeroZeroProps) {
  const layoutType = useLayoutType();
  const router = useRouter();

  return (
    <HeroZeroUi
      layoutType={layoutType}
      title={title}
      description={description}
      breadcrumbs={breadcrumbs.map((crumb) => ({
        ...crumb,
        onClick(e) {
          if (crumb.href && !e.metaKey) {
            e.preventDefault();
            router.push(crumb.href);
          }

          crumb.onClick?.(e);
        },
      }))}
      buttons={buttons as HeroZeroPropsUi['buttons']}
      backgroundColor={backgroundColor}
      showBottomPadding={showBottomPadding}
    />
  );
}

export { HeroZero };
